export default __webpack_public_path__ + "34293465111d617ee5a4705a2f99b202.jpg";